import React from "react";
import style from "./index.module.css";
import banner from "./image/banner.jpg";

function ScopeBusiness() {
  return (
    <>
      <div className={style.banner}>
        <img src={banner} alt="专注金融服务 创造信用财富" />
      </div>
      <div className={style.content}>
        <article>
          {/* <header>
          <span />
          <div>
            <h3>业务范围</h3>
            <h4>BUSINESS SCOPE</h4>
          </div>
          <span />
        </header> */}
          <ul className={style.business}>
            <li>
              <div className={style.pc1}>
                <span>融资性担保业务</span>
              </div>
              <p>
                贷款担保、票据承兑担保、贸易融资
                担保、项目融资担保、信用证担保等 融资业务.
              </p>
            </li>
            <li>
              <div className={style.pc2}>
                <span>非融资性担保</span>
              </div>
              <p>
                诉讼保全担保
                <br />
                履约担保等
              </p>
            </li>
            <li>
              <div className={style.pc3}>
                <span>其他业务</span>
              </div>
              <p>与担保有关的融资咨询财务顾问等</p>
            </li>
          </ul>
        </article>
      </div>
    </>
  );
}

export default ScopeBusiness;
